"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validate = require("validate.js");
const moment = require("moment");
const medicareNumber_1 = require("./validations/medicareNumber");
const remoteCheck_1 = require("./validations/remoteCheck");
const mustEqual_1 = require("./validations/mustEqual");
const dvaNumber_1 = require("./validations/dvaNumber");
const concessionCardNumber_1 = require("./validations/concessionCardNumber");
const maxLength_1 = require("./validations/maxLength");
const dateFormat_1 = require("./validations/dateFormat");
const remoteSuggestionValidator_1 = require("./validations/remoteSuggestionValidator");
const deepWithin_1 = require("./validations/deepWithin");
// Add custom validators to the validator
validate.validators.medicareNumber = medicareNumber_1.default;
validate.validators.remoteCheck = remoteCheck_1.default;
validate.validators.mustEqual = mustEqual_1.default;
validate.validators.dvaNumber = dvaNumber_1.default;
validate.validators.concessionCardNumber = concessionCardNumber_1.default;
validate.validators.maxLength = maxLength_1.default;
validate.validators.dateFormat = dateFormat_1.default;
validate.validators.remoteSuggestionValidator = remoteSuggestionValidator_1.default;
validate.validators.deepWithin = deepWithin_1.deepWithin;
// Override original dateTime
validate.extend(validate.validators.datetime, {
    // The value is guaranteed not to be null or undefined but otherwise it
    // could be anything.
    parse: function (value, options) {
        // Strict on what format we accept
        const date = moment(value, options.format, true);
        if (!date.isValid())
            return NaN;
        return date.unix();
    },
    // Input is a unix timestamp
    format: function (value, options) {
        return moment.utc(value).format(options.format);
    }
});
exports.default = validate;
//# sourceMappingURL=index.js.map